export class SessionNotFoundError extends Error {
    unauthorized = true;
    constructor(message) {
        super(message || 'Sesión no encontrada');
        this.name = 'SessionNotFoundError';
    }
}
//# sourceMappingURL=session_not_found_error.js.map